import ConfigState from './config-state';
import Action from '../../state/action';
import mergeConfig from '../services/merge-config';
import { DefaultConfig } from '../types/config';

const configReducer = (state: ConfigState, action: Action): ConfigState => {
  switch (action.type) {
    case 'parse-config':
      return state.type === 'default'
        ? {
            type: 'parsed',
            parsedConfig: action.parsedConfig,
            config: mergeConfig(DefaultConfig, {}, action.parsedConfig),
          }
        : state;
    case 'theme-config':
      return state.type === 'parsed'
        ? {
            type: 'themed',
            config: mergeConfig(DefaultConfig, action.themedConfig, state.parsedConfig),
          }
        : state;
    default:
      return state;
  }
};

export default configReducer;
